
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQ from './FAQ';
import GoogleTagManager from '../components/GoogleTagManager';


function Mumbaitomahabalehsawar() {



    const cardData =
    {
        keyword: ' Mumbai to Mahabaleshwar Cab  ',
        heading: 'Deva Cabs: Mumbai to Mahabaleshwar Cab  ',
        headingDescription: 'Deva Cabs provides smooth and scenic cab services from Mumbai to Mahabaleshwar, perfect for family holidays, honeymoon trips, and weekend escapes. Situated about 260 km from Mumbai, Mahabaleshwar is a popular hill station known for its cool climate and strawberry farms. Our fleet includes Sedans, SUVs, and Innova Crysta, ensuring a comfortable ride through the Western Ghats. With experienced drivers, fixed fares, and 24/7 service, Deva Cabs guarantees a safe and enjoyable journey to Mahabaleshwar.',

        top: 'Top Places to Visit in Mahabaleshwar with Deva Cabs',

"topPlaces": [
  {
    "title": "Venna Lake",
    "location": "Mahabaleshwar, Maharashtra",
    "description": "Venna Lake is a beautiful man-made lake surrounded by lush greenery and hills. It offers paddle boating, row boating, and horse riding along the lakeside. With its scenic views and calm waters, it's a favorite spot for families and couples visiting Mahabaleshwar."
  },
  {
    "title": "Elephant’s Head Point",
    "location": "Mahabaleshwar, Maharashtra",
    "description": "Elephant’s Head Point is a unique rock formation resembling the head of an elephant, offering panoramic views of the Sahyadri valleys. It's one of the most picturesque viewpoints in Mahabaleshwar, especially popular for photography during misty mornings and sunsets."
  },
  {
    "title": "Arthur’s Seat",
    "location": "Mahabaleshwar, Maharashtra",
    "description": "Arthur’s Seat is known as the 'Queen of the Points' for its dramatic cliffside views. It overlooks the deep Savitri Valley on one side and the lush green plateau on the other, making it a breathtaking destination for nature lovers and trekkers."
  },
  {
    "title": "Mapro Garden",
    "location": "Panchgani-Mahabaleshwar Road, Maharashtra",
    "description": "Mapro Garden is a popular tourist attraction known for its strawberry products, lush gardens, and food court. Visitors can enjoy fresh fruit juices, sandwiches, and chocolates while shopping for jams and syrups. It’s especially vibrant during the annual Strawberry Festival."
  },
  {
    "title": "Pratapgad Fort",
    "location": "Near Mahabaleshwar, Maharashtra",
    "description": "Pratapgad Fort is a historical hill fort built by Chhatrapati Shivaji Maharaj. It offers stunning views, Maratha architecture, and significance as the site of the famous battle between Shivaji and Afzal Khan. The fort is a blend of history and nature, making it a must-visit spot."
  },
  {
    "title": "Lingmala Waterfall",
    "location": "Mahabaleshwar, Maharashtra",
    "description": "Lingmala Waterfall is a spectacular natural attraction where water cascades down from a height of over 600 feet. Best visited during the monsoon, the falls are surrounded by thick forests and offer a peaceful escape into nature with a short trek through green trails."
  },
  {
    "title": "Wilson Point",
    "location": "Mahabaleshwar, Maharashtra",
    "description": "Wilson Point is the highest point in Mahabaleshwar at 4,710 feet above sea level. It's the only place in the town where you can witness both sunrise and sunset. The flat plateau with multiple viewpoints offers panoramic views of the surrounding hills and valleys."
  },
  {
    "title": "Panchganga Temple",
    "location": "Mahabaleshwar, Maharashtra",
    "description": "Panchganga Temple is an ancient religious site where five rivers—Krishna, Venna, Savitri, Koyna, and Gayatri—are believed to originate. The temple’s sacred tank and historical significance make it a spiritual highlight of Mahabaleshwar."
  },
  {
    "title": "Kate’s Point and Needle Hole Point",
    "location": "Mahabaleshwar, Maharashtra",
    "description": "Kate’s Point offers spectacular views of Dhom Dam and the surrounding valleys. Nearby Needle Hole Point features a natural rock formation that looks like a hole pierced through a mountain. Both points are popular for sightseeing and photography."
  },
  {
    "title": "Babington Point",
    "location": "Mahabaleshwar, Maharashtra",
    "description": "Babington Point is a lesser-known viewpoint surrounded by dense forests and walking trails. It's a quiet spot for nature lovers, offering views of the Solshi and Koyna valleys. Ideal for birdwatchers and those looking to escape the crowds."
  }
],



"services": [
  {
    "name": "Mumbai to Mahabaleshwar Cab",
    "description": "Experience a scenic and comfortable drive from Mumbai to Mahabaleshwar with Deva Cabs’ trusted outstation cab service. Whether you're planning a family trip, a romantic getaway, or a weekend with friends, our cabs provide a smooth, reliable journey to this lush hill station. Enjoy door-to-door service, expert drivers, and a variety of vehicle options to suit your group size and budget."
  },
  {
    "name": "One-way cab Mumbai to Mahabaleshwar",
    "description": "Planning a one-way trip to Mahabaleshwar? Deva Cabs offers affordable one-way cab services from Mumbai with no return fare. This service is ideal for travelers who have flexible plans or are staying longer in Mahabaleshwar. Choose from hatchbacks, sedans, or SUVs and travel worry-free with verified drivers and well-maintained cars."
  },
  {
    "name": "Book Mahabaleshwar cab Mumbai",
    "description": "Booking your Mahabaleshwar cab from Mumbai is fast and easy with Deva Cabs. You can reserve your ride online or by phone with instant confirmation and transparent fares. Select your preferred vehicle, set your schedule, and enjoy a personalized ride experience to one of Maharashtra’s most loved hill stations."
  },
  {
    "name": "AC taxi Mumbai to Mahabaleshwar",
    "description": "Stay cool on your journey to the hills with our fully air-conditioned taxis from Mumbai to Mahabaleshwar. Our AC cabs are perfect for summer getaways and offer a relaxing environment throughout the long ride. Travel in comfort with chilled cabins, clean interiors, and courteous drivers."
  },
  {
    "name": "SUV cab hire Mumbai to Mahabaleshwar",
    "description": "Travel in spacious comfort with our SUV cabs to Mahabaleshwar. Ideal for families or groups, our SUVs offer extra legroom, ample luggage space, and a smooth ride through hilly terrain. Whether you're headed for sightseeing, strawberry farms, or just cool mountain air, an SUV is your best bet for comfort and safety."
  },
  {
    "name": "Chauffeur-driven cab Mumbai to Mahabaleshwar",
    "description": "Relax and enjoy the journey with our professional chauffeur-driven cabs from Mumbai to Mahabaleshwar. Our drivers are trained, experienced, and polite — making sure your trip is stress-free and pleasant. We take care of all the driving while you enjoy the scenic route and fresh air."
  },
  {
    "name": "Round trip Mahabaleshwar cab from Mumbai",
    "description": "Planning to return the same day or the next? Our round trip cab service from Mumbai to Mahabaleshwar gives you the flexibility of a fixed vehicle and driver at your convenience. Ideal for weekend trips, family holidays, or quick retreats, our cabs wait for you and bring you back safely."
  },
  {
    "name": "Luxury cab Mumbai to Mahabaleshwar",
    "description": "Make your hill station vacation more luxurious with our premium cab options from Mumbai to Mahabaleshwar. Travel in style with top-end sedans or executive SUVs featuring plush interiors, leather seats, and professional chauffeurs. Ideal for couples, honeymooners, or those who love a premium experience."
  },
  {
    "name": "Affordable cab hire Mumbai to Mahabaleshwar",
    "description": "Enjoy budget-friendly travel without compromising on comfort with Deva Cabs’ affordable taxi service to Mahabaleshwar. We offer clean, reliable hatchbacks and sedans with fixed pricing, no hidden charges, and 24/7 customer support. Great for students, small families, or frequent travelers."
  },
  {
    "name": "Family cab Mumbai to Mahabaleshwar",
    "description": "Travel with your loved ones in our specially selected family cabs from Mumbai to Mahabaleshwar. Our vehicles are spacious, safe, and come with professional drivers who ensure a smooth and patient drive, even with kids or elderly passengers onboard."
  },
  {
    "name": "Mumbai to Mahabaleshwar sightseeing cab",
    "description": "Turn your cab ride into a sightseeing journey with Deva Cabs. Our drivers are familiar with key tourist spots and can guide you through must-see attractions in Mahabaleshwar like Arthur's Seat, Venna Lake, and Mapro Garden. Add a scenic flavor to your commute with optional sightseeing stops."
  },
  {
    "name": "Weekend trip cab Mumbai to Mahabaleshwar",
    "description": "Planning a quick weekend getaway? Our special weekend cab packages from Mumbai to Mahabaleshwar come with flexible pickup/drop timings, round trip options, and great pricing. Perfect for Friday-to-Sunday trips or last-minute bookings with guaranteed comfort."
  },
  {
    "name": "Online cab booking Mahabaleshwar",
    "description": "Skip the hassle and book your Mumbai to Mahabaleshwar cab online with Deva Cabs. Our website and mobile interface are fast, secure, and user-friendly. You can compare prices, vehicle types, and get instant confirmation with no hidden charges."
  },
  {
    "name": "Corporate cab Mumbai to Mahabaleshwar",
    "description": "Send your team or clients to Mahabaleshwar in style with our corporate cab services. We offer clean, GPS-enabled vehicles with trained drivers and business-friendly billing. Whether it’s a company retreat or executive travel, we ensure punctuality, comfort, and professionalism."
  },
  {
    "name": "Premium cab Mumbai to Mahabaleshwar",
    "description": "Deva Cabs provides a premium travel experience from Mumbai to Mahabaleshwar. Our high-end cabs include top-tier models, bottled water, Wi-Fi (on request), and well-groomed drivers. It’s the ideal choice for anyone seeking a first-class road journey to the hills."
  }
],
"tableData": [
  ["Mumbai to Mahabaleshwar Cab", "-One-way cab Mumbai to Mahabaleshwar"],
  ["Book Mahabaleshwar cab Mumbai", "-AC taxi Mumbai to Mahabaleshwar"],
  ["SUV cab hire Mumbai to Mahabaleshwar", "-Chauffeur-driven cab Mumbai to Mahabaleshwar"],
  ["Round trip Mahabaleshwar cab from Mumbai", "-Luxury cab Mumbai to Mahabaleshwar"],
  ["Affordable cab hire Mumbai to Mahabaleshwar", "-Family cab Mumbai to Mahabaleshwar"],
  ["Mumbai to Mahabaleshwar sightseeing cab", "-Weekend trip cab Mumbai to Mahabaleshwar"],
  ["Online cab booking Mahabaleshwar", "-Corporate cab Mumbai to Mahabaleshwar"],
  ["Premium cab Mumbai to Mahabaleshwar", ""]
],

whychoose: [
  {
    "WhyChooseheading": "Reliable Mumbai to Mahabaleshwar Cab Service",
    "WhyChoosedescription": "Our Mumbai to Mahabaleshwar cab service ensures timely and dependable transportation for all travelers. Whether you're heading for a weekend hill station getaway, a family vacation, or a corporate retreat, we prioritize punctuality and convenience. Starting from your doorstep in Mumbai, we guarantee smooth coordination and a hassle-free journey to the beautiful hill station of Mahabaleshwar."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles for Long Journeys",
    "WhyChoosedescription": "Enjoy the scenic drive to Mahabaleshwar in our well-maintained, air-conditioned vehicles designed for comfort on long trips. With ergonomic seating, ample legroom, and sufficient luggage space, our cars are ideal for solo travelers, families, and groups. Relax and unwind as you travel through the Western Ghats, arriving refreshed and ready to explore."
  },
  {
    "WhyChooseheading": "Experienced Drivers Skilled in Hill Station Routes",
    "WhyChoosedescription": "Our drivers have extensive experience navigating the Mumbai to Mahabaleshwar route, including the winding roads and mountainous terrain. They prioritize safety and customer comfort, ensuring a smooth and secure ride. Additionally, our drivers are familiar with local attractions and can provide useful travel tips and suggestions during your journey."
  },
  {
    "WhyChooseheading": "Transparent and Competitive Pricing",
    "WhyChoosedescription": "We offer clear and upfront pricing with no hidden charges, including fuel, tolls, and driver allowances. Our competitive rates ensure you get value for money while enjoying premium service. Receive a detailed fare breakdown before your trip to plan your budget confidently."
  },
  {
    "WhyChooseheading": "24/7 Availability for Flexible Travel Plans",
    "WhyChoosedescription": "Our cabs are available round-the-clock to accommodate your travel schedule, whether it’s an early morning departure or a late-night return. We understand that plans can change, so our 24/7 service ensures you can book a ride anytime, including weekends and holidays."
  },
  {
    "WhyChooseheading": "Easy Booking with Instant Confirmation",
    "WhyChoosedescription": "Booking your Mumbai to Mahabaleshwar cab is quick and straightforward through our website or customer support. You’ll receive instant confirmation, driver details, and updates, ensuring transparency and peace of mind throughout your trip planning and travel."
  },
  {
    "WhyChooseheading": "Safety and Well-Maintained Vehicles",
    "WhyChoosedescription": "Your safety is our top priority. All vehicles are regularly serviced, sanitized, and equipped with modern safety features such as seat belts, GPS tracking, and emergency kits. Our drivers adhere to strict safety protocols, especially on hill roads, providing a secure and comfortable travel experience."
  },
  {
    "WhyChooseheading": "Customized Travel Options for Your Convenience",
    "WhyChoosedescription": "We offer flexible travel packages tailored to your needs, including one-way trips, round trips, and multiple stops along the way. Whether traveling solo, with family, or in a group, our service adapts to your itinerary, ensuring a personalized and stress-free journey to Mahabaleshwar."
  }
]







    }









const faqData = [
  {
    question: "Can I book a cab from Mumbai to Mahabaleshwar with Deva Cabs?",
    answer: "Yes, Deva Cabs offers reliable and comfortable cab services from Mumbai to Mahabaleshwar for weekend getaways, holidays, and family trips."
  },
  {
    question: "How long does it take to travel from Mumbai to Mahabaleshwar by cab?",
    answer: "The journey usually takes around 5 to 6 hours depending on traffic and road conditions."
  },
  {
    question: "What types of vehicles are available for Mumbai to Mahabaleshwar?",
    answer: "We offer sedans, SUVs, Ertiga, Innova Crysta, and tempo travellers for both individual and group travel."
  },
  {
    question: "Can I schedule a pickup for early morning or late night travel?",
    answer: "Yes, Deva Cabs operates 24/7, so you can schedule your pickup at any time that suits your travel plan."
  },
  {
    question: "Are one-way cab services available from Mumbai to Mahabaleshwar?",
    answer: "Yes, Deva Cabs provides affordable one-way cab options without return fare obligations."
  },
  {
    question: "Are toll, parking, and driver charges included in the fare?",
    answer: "These charges are usually additional and will be transparently communicated during booking."
  },
  {
    question: "Can I book a round trip from Mumbai to Mahabaleshwar with Deva Cabs?",
    answer: "Yes, we offer flexible round trip packages with same-day or extended return options."
  },
  {
    question: "Is it safe to travel alone with Deva Cabs?",
    answer: "Absolutely. Our drivers are background-verified and trained to ensure a safe and comfortable journey."
  },
  {
    question: "What are some places we can visit in Mahabaleshwar with the cab?",
    answer: "With our cab service, you can visit popular spots like Arthur's Seat, Mapro Garden, Venna Lake, Wilson Point, and more."
  },
  {
    question: "Why choose Deva Cabs for Mumbai to Mahabaleshwar travel?",
    answer: "Deva Cabs offers well-maintained vehicles, courteous drivers, timely service, and transparent pricing for a worry-free trip."
  }
];

const testimonialData = [
  {
    id: 39,
    name: 'Mr. Nilesh Bhosale',
    role: 'Weekend Tourist',
    review: 'Our trip from Mumbai to Mahabaleshwar with Deva Cabs was fantastic. The driver was polite and professional, and the cab was in great condition.',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  },
  {
    id: 40,
    name: 'Ms. Rina Salvi',
    role: 'Family Traveler',
    review: 'Highly recommend Deva Cabs for trips to Mahabaleshwar! The cab arrived on time, the driver was helpful, and the ride was super comfortable.',
    rating: 5,
    quoteIcon: '/img/icon/testi-quote.svg',
  }
];








































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8108807171",
            "+91 9764227171",



        ],
        email: "booking@devacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Cab Service in Mumbai",
            link: "/Cab-Service-in-Mumbai"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Cab Service in Navi Mumbai",
            link: "/Cab-Service-in-Navi-Mumbai"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Cab Service in Thane",
            link: "/Cab-Service-in-Thane"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Cab Service Near Me Mumbai",
            link: "/Cab-Service-Near-Me-Mumbai"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Car Rental in Mumbai",
            link: "/Car-Rental-in-Mumbai"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Corporate Cab Services in Mumbai",
            link: "/Corporate-Cab-Services-in-Mumbai"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Online Taxi Booking Mumbai",
            link: "/Online-Taxi-Booking-Mumbai"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Wedding Car Rental Mumbai",
            link: "/Wedding-Car-Rental-Mumbai"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Tempo Traveller on Rent in Mumbai",
            link: "/Tempo-Traveller-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Innova Crysta on Rent in Mumbai",
            link: "/Innova-Crysta-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Ertiga on Rent in Mumbai",
            link: "/Ertiga-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Mini Bus on Rent in Mumbai",
            link: "/Mini-Bus-on-Rent-in-Mumbai"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Mumbai Airport Cab Booking",
            link: "/Mumbai-Airport-Cab-Booking"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Navi Mumbai Car Rental Service",
            link: "/Navi-Mumbai-Car-Rental-Service"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mumbai Airport to Pune Cab",
            link: "/Mumbai-Airport-to-Pune-Cab"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai Airport to Shirdi Taxi",
            link: "/Mumbai-Airport-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Mumbai Airport Cab",
            link: "/Pune-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Airport to Mumbai Cab",
            link: "/Pune-Airport-to-Mumbai-Cab"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Surat to Mumbai Airport Taxi",
            link: "/Surat-to-Mumbai-Airport-Taxi"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Nashik to Mumbai Airport Cab",
            link: "/Nashik-to-Mumbai-Airport-Cab"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Nashik Cab",
            link: "/Mumbai-to-Nashik-Cab"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Shirdi Cab",
            link: "/Mumbai-to-Shirdi-Cab"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai to Lonavala Cab",
            link: "/Mumbai-to-Lonavala-Cab"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Mumbai to Khandala Cab",
            link: "/Mumbai-to-Khandala-Cab"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Lavasa Cab",
            link: "/Mumbai-to-Lavasa-Cab"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Matheran Cab",
            link: "/Mumbai-to-Matheran-Cab"
        }
    ];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Mahabaleshwar Cab",
  "image": "https://devacab.com/assets/images/mumbai-to-mahabaleshwar-cab.jpg", // Replace with actual image URL if different
  "description": "Book Mumbai to Mahabaleshwar cab with Deva Cabs for a comfortable and affordable journey. Choose from hatchbacks, sedans, SUVs and tempo travellers. Reliable service with professional drivers for one-way or round trips.",
  "brand": {
    "@type": "Brand",
    "name": "Deva Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "3210"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3499",
    "availability": "https://schema.org/InStock",
    "url": "https://devacab.com/mumbai-to-mahabaleshwar-cab"
  }
};






    return (
        <div>
<GoogleTagManager/>
<Helmet>
  <title>Mumbai to Mahabaleshwar Cab | One Way & Round Trip Taxi - Deva Cabs</title>
  <meta 
    name="description" 
    content="Book Mumbai to Mahabaleshwar cab at lowest fare with Deva Cabs. Clean cars, experienced drivers, and on-time service. One-way & round-trip taxi options available in hatchbacks, sedans, SUVs & tempo travellers." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Mahabaleshwar Cab, Mumbai to Mahabaleshwar Taxi, Cab from Mumbai to Mahabaleshwar, One Way Cab Mumbai to Mahabaleshwar, Mumbai to Mahabaleshwar Car Rental, Mumbai to Mahabaleshwar Cabs with driver, Mumbai to Mahabaleshwar Tempo Traveller, SUV cab Mumbai to Mahabaleshwar, Sedan cab from Mumbai to Mahabaleshwar, Taxi Service Mumbai to Mahabaleshwar, Deva Cabs Mumbai to Mahabaleshwar, Online cab booking Mumbai to Mahabaleshwar, Mumbai to Mahabaleshwar Outstation Cab, Affordable cab Mumbai Mahabaleshwar" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div className="breadcumb-wrapper" >
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/28.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Deva Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1" key={e.text}>
                                        <a
                                            href={e.link} // Use the separate link for each item
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt={e.text} />
                                            </div>
                                            <div className="b2">
                                                <a href={e.link} className="px-3 colorr">{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #562018',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#562018' }}>
                                            <h4 className=" lead fw-semibold whitt text-white bg-ora">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 8108807171" className="d-block  text-white">+91 8108807171</a>
                                                <a href="tel:+91 9764227171" className="d-block  text-white">+91 9764227171</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Email</h4>
                                                <a href="mailto:booking@devacab.com" className=" text-white d-block">
                                                    booking@devacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#562018' }}>
                                                <h4 className=" fw-semibold lead whitt text-white bg-ora">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Deva Cabs<br />
                                                        SS-2 404 Sector -17 Behind Mother India School Koparkhairne Navi Mumbai 400709
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Mumbaitomahabalehsawar;